var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"mm-menu-item-group"},[_c('div',{staticClass:"mm-menu-item-group-title",style:({
      paddingLeft: _vm.levelPadding + 'px'
    })},[_vm._t("title",function(){return [_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]})],2),_c('ul',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }